import { futureAssignment } from "./test.action";
import {
  ASSIGNMENT_IN_PROGRESS_FAILURE,
  ASSIGNMENT_IN_PROGRESS_SUCCESS,
  FUTURE_ASSIGNMENT_FAILURE,
  FUTURE_ASSIGNMENT_QUESTIONS_FAILURE,
  FUTURE_ASSIGNMENT_QUESTIONS_SUCCESS,
  FUTURE_ASSIGNMENT_SUCCESS,
  GENERATE_TEST_FAILURE,
  GENERATE_TEST_SUCCESS,
  HISTORY_FAILURE,
  HISTORY_NOT_ATTEMPTED_FAILURE,
  HISTORY_NOT_ATTEMPTED_SUCCESS,
  HISTORY_SUCCESS,
  SEE_ANSWERS_FAILURE,
  SEE_ANSWERS_SUCCESS,
  SUBJECT_CHAPTER_FAILURE,
  SUBJECT_CHAPTER_SUCCESS,
  SUBMISSION_DATA_FAILURE,
  SUBMISSION_DATA_SUCCESS,
  SUBMIT_ANSWERS_FAILURE,
  SUBMIT_ANSWERS_SUCCESS,
  TEST_RESULT_FAILURE,
  TEST_RESULT_SUCCESS,
} from "./test.actionTypes";

const initialState = {
  questionsList: [],
  testDetails: null,
  subjectChapter: null,
  assignmentHistory: null,
  futureAssignment: null,
  futureAssignmentQuestions: null,
  submissionData: null,
  submittedAnswers: null,
  seeAnswers: null,
  inProgressAssignment: null,
  assignHistoryNotAttempted: null
};

export default function testReducer(state = initialState, { type, payload }) {
  switch (type) {
    case GENERATE_TEST_SUCCESS:
      const newEntry = {
        questionsList: payload.data,
        subjectName: payload.subjectName,
        chapterArray: payload.chapterArray,
      };

      return {
        ...state,
        questionsList: [...state.questionsList.slice(-1), newEntry],
      };

    case GENERATE_TEST_FAILURE:
      return {
        ...state,
        message: "",
      };

    case TEST_RESULT_SUCCESS:
      return {
        ...state,
        // userAnswersArray: payload.userAnswersArray,
        responseFromResult: payload.response,
      };
    case TEST_RESULT_FAILURE:
      return {
        ...state,
        message: "",
      };

    case SUBJECT_CHAPTER_SUCCESS:
      return {
        ...state,
        subjectChapter: payload,
      };
    case SUBJECT_CHAPTER_FAILURE:
      return {
        ...state,
        message: "",
      };

    case HISTORY_SUCCESS:
      return {
        ...state,
        assignmentHistory: payload,
      };
    case HISTORY_FAILURE:
      return {
        ...state,
        message: "",
      };

    case FUTURE_ASSIGNMENT_SUCCESS:
      return {
        ...state,
        futureAssignment: payload,
      };
    case FUTURE_ASSIGNMENT_FAILURE:
      return {
        ...state,
        message: "",
      };

    case FUTURE_ASSIGNMENT_QUESTIONS_SUCCESS:
      return {
        ...state,
        futureAssignmentQuestions: payload,
      };
    case FUTURE_ASSIGNMENT_QUESTIONS_FAILURE:
      return {
        ...state,
        message: "",
      };
    case SUBMISSION_DATA_SUCCESS:
      return {
        ...state,
        submissionData: payload,
      };
    case SUBMISSION_DATA_FAILURE:
      return {
        ...state,
        message: "",
      };

    case SUBMIT_ANSWERS_SUCCESS:
      return {
        ...state,
        submittedAnswers: payload,
      };
    case SUBMIT_ANSWERS_FAILURE:
      return {
        ...state,
        message: "",
      };

    case SEE_ANSWERS_SUCCESS:
      return {
        ...state,
        seeAnswers: payload,
      };
    case SEE_ANSWERS_FAILURE:
      return {
        ...state,
        message: "",
      };

    case ASSIGNMENT_IN_PROGRESS_SUCCESS:
      return {
        ...state,
        inProgressAssignment: payload,
      };
    case ASSIGNMENT_IN_PROGRESS_FAILURE:
      return {
        ...state,
        message: "",
      };

          case HISTORY_NOT_ATTEMPTED_SUCCESS:
      return {
        ...state,
        assignHistoryNotAttempted: payload,
      };
    case HISTORY_NOT_ATTEMPTED_FAILURE:
      return {
        ...state,
        message: "",
      };

    default:
      return state;
  }
}
